import { Toaster, TooltipProvider } from '@gestao/ui'
import { type QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { ReactNode } from 'react'

import { queryClient as defaultQueryClient } from '../lib/query-client'

interface ProvidersProps {
  children: ReactNode
  queryClient?: QueryClient
}

/** Provedores globais: consultas (TanStack Query), tooltips e a região de toasts (aria-live). */
export function Providers({ children, queryClient = defaultQueryClient }: ProvidersProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider delayDuration={300}>
        {children}
        <Toaster />
      </TooltipProvider>
    </QueryClientProvider>
  )
}
